module.exports = __webpack_public_path__ + "static/media/shape0_0.3c50f049.obj";